"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AffixSt = require("./Affix.st.css");
var _InputConsumer = _interopRequireDefault(require("../InputConsumer"));
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/Input/Affix/Affix.js";
var Affix = _ref => {
  var {
    children,
    value
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_InputConsumer.default, {
    consumerCompName: Affix.displayName,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 3
    }
  }, _ref2 => {
    var {
      size,
      inPrefix,
      inSuffix,
      border,
      disabled,
      onInputClicked
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _AffixSt.st)(_AffixSt.classes.root, {
        size,
        inPrefix,
        inSuffix,
        border,
        disabled
      }),
      onClick: onInputClicked,
      "data-hook": "custom-affix",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9,
        columnNumber: 7
      }
    }, value || children);
  });
};
Affix.displayName = 'Input.Affix';
Affix.propTypes = {
  children: _propTypes.default.node,
  value: _propTypes.default.string
};
var _default = exports.default = Affix;
//# sourceMappingURL=Affix.js.map